import { Link } from 'react-router-dom';
import { galleryItems } from '../../../mocks/galleryItems';

export default function GalleryPreview() {
  const previewItems = galleryItems.slice(0, 6);

  return (
    <section className="bg-[#1C1C1C] py-28 px-16">
      <div className="max-w-[1300px] mx-auto">
        {/* Header */}
        <div className="flex items-end justify-between mb-16">
          <div>
            <p className="text-gold text-[10px] tracking-[0.3em] uppercase font-sans mb-4">
              Portfolio
            </p>
            <h2 className="font-serif text-cream text-5xl font-light tracking-wide">
              Gallery
            </h2>
          </div>
          <Link
            to="/gallery"
            className="inline-flex items-center gap-3 border border-cream/15 text-cream/40 text-[10px] tracking-[0.2em] uppercase px-8 py-3 hover:border-gold/50 hover:text-gold transition-all duration-300 font-sans whitespace-nowrap cursor-pointer"
          >
            View All
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        </div>

        {/* Gallery grid */}
        <div className="grid grid-cols-3 gap-3">
          {previewItems.map((item) => (
            <div
              key={item.id}
              className="group relative aspect-square overflow-hidden cursor-pointer"
              style={{ backgroundColor: item.bgColor }}
            >
              {/* Corner accents */}
              <div className="absolute top-4 left-4 w-6 h-6 border-l border-t opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ borderColor: item.accentColor }} />
              <div className="absolute bottom-4 right-4 w-6 h-6 border-r border-b opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ borderColor: item.accentColor }} />

              {/* Content */}
              <div className="absolute inset-0 flex flex-col items-center justify-center p-8">
                {/* Decorative element */}
                <div className="w-10 h-px mb-6 opacity-40"
                  style={{ backgroundColor: item.accentColor }} />
                <p className="font-serif text-xl font-light tracking-widest text-center mb-2"
                  style={{ color: item.accentColor }}>
                  {item.title}
                </p>
                <p className="text-[10px] tracking-[0.2em] uppercase font-sans font-light text-center mb-4"
                  style={{ color: `${item.accentColor}70` }}>
                  {item.subtitle}
                </p>
                <div className="w-10 h-px opacity-40"
                  style={{ backgroundColor: item.accentColor }} />
              </div>

              {/* Category badge */}
              <div className="absolute top-4 right-4 px-2 py-1 text-[9px] tracking-[0.15em] uppercase font-sans"
                style={{ border: `1px solid ${item.accentColor}40`, color: `${item.accentColor}90` }}>
                {item.category}
              </div>

              {/* Overlay on hover */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ backgroundColor: `${item.accentColor}08` }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
